import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import './Legal.css';

const PolitiqueConfidentialite = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-content">
          <img 
            src="https://customer-assets.emergentagent.com/job_pro-service-hub-5/artifacts/w0r3tvio_APP%20ICON.png" 
            alt="ZotPro Logo" 
            className="legal-logo"
          />
          <Button onClick={() => navigate('/')} className="back-btn">
            <ArrowLeft size={20} />
            Retour à l'accueil
          </Button>
        </div>
      </header>

      <div className="legal-container">
        <h1 className="legal-title">Politique de Confidentialité</h1>
        <p className="legal-date">Dernière mise à jour : Décembre 2025</p>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            La présente politique de confidentialité a pour but d'informer les utilisateurs du site 
            ZotPro sur la manière dont leurs données personnelles sont collectées, utilisées et protégées 
            par SARL DEALRUN (ci-après "nous", "notre" ou "DEALRUN").
          </p>
          <p>
            DEALRUN s'engage à protéger la vie privée de ses utilisateurs et à traiter leurs données 
            personnelles conformément au Règlement Général sur la Protection des Données (RGPD) et à 
            la loi Informatique et Libertés.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Responsable du traitement</h2>
          <p>Le responsable du traitement de vos données personnelles est :</p>
          <ul>
            <li><strong>SARL DEALRUN</strong></li>
            <li><strong>SIRET :</strong> 89535078300018</li>
            <li><strong>Adresse :</strong> 33 Boulevard du Mahatma Gandhi, Sainte Clotilde, 97490 Saint-Denis, La Réunion</li>
            <li><strong>Téléphone :</strong> 0693463628</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Données collectées</h2>
          <h3>3.1. Données de pré-inscription</h3>
          <p>Lors de votre pré-inscription sur ZotPro, nous collectons les données suivantes :</p>
          <ul>
            <li>Prénom et nom</li>
            <li>Adresse email</li>
            <li>Numéro de téléphone</li>
            <li>Nom de la société (optionnel)</li>
            <li>Numéro SIRET (optionnel)</li>
            <li>Catégories et sous-catégories de services sélectionnées</li>
            <li>Date et heure de l'inscription</li>
          </ul>

          <h3>3.2. Données de navigation</h3>
          <p>Nous collectons automatiquement certaines informations lors de votre visite sur notre site :</p>
          <ul>
            <li>Adresse IP</li>
            <li>Type et version du navigateur</li>
            <li>Système d'exploitation</li>
            <li>Pages visitées et durée de consultation</li>
            <li>Date et heure de connexion</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Finalités du traitement</h2>
          <p>Vos données personnelles sont collectées et traitées pour les finalités suivantes :</p>
          <ul>
            <li><strong>Gestion des pré-inscriptions :</strong> Enregistrer votre intérêt pour la plateforme ZotPro</li>
            <li><strong>Communication :</strong> Vous informer du lancement de la plateforme et des offres promotionnelles</li>
            <li><strong>Amélioration du service :</strong> Analyser les besoins des professionnels pour adapter notre offre</li>
            <li><strong>Statistiques :</strong> Réaliser des analyses statistiques sur l'utilisation du site</li>
            <li><strong>Respect des obligations légales :</strong> Répondre aux obligations légales et réglementaires</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. Base légale du traitement</h2>
          <p>Le traitement de vos données personnelles repose sur les bases légales suivantes :</p>
          <ul>
            <li><strong>Consentement :</strong> Vous consentez au traitement de vos données en soumettant le formulaire de pré-inscription</li>
            <li><strong>Intérêt légitime :</strong> Nous avons un intérêt légitime à améliorer nos services et à communiquer avec vous</li>
            <li><strong>Obligation légale :</strong> Certaines données sont conservées pour respecter nos obligations légales (comptabilité, fiscalité)</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Destinataires des données</h2>
          <p>Vos données personnelles sont destinées aux services internes de DEALRUN et peuvent être transmises à :</p>
          <ul>
            <li>Notre personnel habilité dans le cadre de leurs fonctions</li>
            <li>Nos prestataires techniques (hébergement, maintenance)</li>
            <li>Les autorités compétentes sur réquisition judiciaire</li>
          </ul>
          <p>
            Nous nous engageons à ne jamais vendre, louer ou échanger vos données personnelles 
            à des tiers à des fins commerciales.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Durée de conservation</h2>
          <p>Vos données personnelles sont conservées pendant les durées suivantes :</p>
          <ul>
            <li><strong>Données de pré-inscription :</strong> 3 ans à compter de votre dernier contact avec nous</li>
            <li><strong>Données de navigation :</strong> 13 mois maximum</li>
            <li><strong>Données comptables :</strong> 10 ans conformément aux obligations légales</li>
          </ul>
          <p>
            À l'issue de ces périodes, vos données seront supprimées ou anonymisées, 
            sauf obligation légale de conservation plus longue.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Sécurité des données</h2>
          <p>
            DEALRUN met en œuvre toutes les mesures techniques et organisationnelles appropriées 
            pour assurer la sécurité et la confidentialité de vos données personnelles, notamment :
          </p>
          <ul>
            <li>Chiffrement des données sensibles (SSL/TLS)</li>
            <li>Authentification sécurisée pour l'accès aux données</li>
            <li>Sauvegardes régulières</li>
            <li>Contrôles d'accès stricts</li>
            <li>Formation du personnel à la protection des données</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>9. Vos droits</h2>
          <p>
            Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :
          </p>
          <ul>
            <li><strong>Droit d'accès :</strong> Obtenir la confirmation que vos données sont traitées et accéder à ces données</li>
            <li><strong>Droit de rectification :</strong> Faire corriger des données inexactes ou incomplètes</li>
            <li><strong>Droit à l'effacement :</strong> Demander la suppression de vos données dans certains cas</li>
            <li><strong>Droit à la limitation :</strong> Demander la limitation du traitement de vos données</li>
            <li><strong>Droit d'opposition :</strong> Vous opposer au traitement de vos données pour des raisons tenant à votre situation particulière</li>
            <li><strong>Droit à la portabilité :</strong> Recevoir vos données dans un format structuré et les transmettre à un autre responsable</li>
            <li><strong>Droit de retirer votre consentement :</strong> Retirer votre consentement à tout moment</li>
          </ul>
          <p>
            Pour exercer ces droits, vous pouvez nous contacter par téléphone au <strong>0693463628</strong> 
            ou par courrier à l'adresse : SARL DEALRUN, 33 Boulevard du Mahatma Gandhi, Sainte Clotilde, 
            97490 Saint-Denis, La Réunion.
          </p>
          <p>
            Vous disposez également du droit d'introduire une réclamation auprès de la Commission 
            Nationale de l'Informatique et des Libertés (CNIL) si vous estimez que vos droits ne 
            sont pas respectés : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Cookies</h2>
          <p>
            Notre site utilise des cookies pour améliorer votre expérience de navigation et 
            réaliser des statistiques de visite.
          </p>
          <h3>10.1. Qu'est-ce qu'un cookie ?</h3>
          <p>
            Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, smartphone, tablette) 
            lors de la visite d'un site web.
          </p>
          <h3>10.2. Types de cookies utilisés</h3>
          <ul>
            <li><strong>Cookies techniques :</strong> Nécessaires au fonctionnement du site</li>
            <li><strong>Cookies analytiques :</strong> Pour mesurer l'audience et améliorer le site</li>
          </ul>
          <h3>10.3. Gestion des cookies</h3>
          <p>
            Vous pouvez configurer votre navigateur pour refuser les cookies ou être averti 
            de leur dépôt. La désactivation des cookies peut affecter certaines fonctionnalités du site.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Transfert de données hors UE</h2>
          <p>
            Vos données personnelles sont stockées et traitées au sein de l'Union Européenne. 
            En cas de transfert vers un pays tiers, nous nous assurons que ce transfert respecte 
            les garanties appropriées prévues par le RGPD.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Modifications de la politique</h2>
          <p>
            DEALRUN se réserve le droit de modifier la présente politique de confidentialité à tout moment. 
            Toute modification sera publiée sur cette page avec indication de la date de mise à jour. 
            Nous vous invitons à consulter régulièrement cette page pour prendre connaissance des 
            éventuelles modifications.
          </p>
        </section>

        <section className="legal-section">
          <h2>13. Contact</h2>
          <p>
            Pour toute question concernant la présente politique de confidentialité ou le traitement 
            de vos données personnelles, vous pouvez nous contacter :
          </p>
          <ul>
            <li><strong>Par téléphone :</strong> 0693463628</li>
            <li><strong>Par courrier :</strong> SARL DEALRUN, 33 Boulevard du Mahatma Gandhi, Sainte Clotilde, 97490 Saint-Denis, La Réunion</li>
          </ul>
        </section>
      </div>

      <footer className="legal-footer">
        <p>© 2025 ZotPro - SARL DEALRUN. Tous droits réservés.</p>
      </footer>
    </div>
  );
};

export default PolitiqueConfidentialite;
